/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   CurrentSearchView whitelist
 */

import { RESET_CLUSTERS_AND_LISTABLES } from '../../../actions/constants'
import * as constants from '../constants'
import * as pinsConstants from '../modules/pins/constants'
import { poiWhitelist } from '../modules/poi/reducers/whitelist'

import type { ActionTypes } from './types'

const whitelist = [
  ...Object.values(constants),
  ...poiWhitelist,
  RESET_CLUSTERS_AND_LISTABLES,
  ...Object.values(pinsConstants),
  // This satisfies makes sure that everything in the whitelist is also used in the reducer
] as const satisfies ReadonlyArray<ActionTypes['type']>

// These 2 lines make sure that every action type that the reducer uses is included in the whitelist
// For example, if you comment out line 17, you get an error on line 25
declare const shouldBeEmpty: Exclude<ActionTypes['type'], (typeof whitelist)[number]>
false && (shouldBeEmpty satisfies never)

export default whitelist
